import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { FieldInputProps } from "formik";
import * as React from "react";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";

type Props = TextFieldProps & {
    errorMessage?: string;
    field: FieldInputProps<string>;
    isTouched?: boolean;
    width?: string;
    optional?: boolean;
};

export const CustomInputField = ({
    style,
    label,
    type,
    autoComplete,
    required,
    errorMessage,
    field,
    select,
    disabled,
    isTouched,
    multiline,
    rows,
    optional,
    InputLabelProps,
    inputProps,
    children,
    onChange,
    onBlur,
    onClick,
    SelectProps,
    ...props
}: Props) => {
    const showError = isTouched && !!errorMessage;

    return (
        <div
            style={{
                flexBasis: 0,
                width: "100%",
                flexGrow: 1,
                ...style
            }}
        >
            <TextField
                label={label}
                value={field.value ?? ""}
                name={field.name}
                multiline={multiline}
                onChange={(event: React.ChangeEvent<any>) => {
                    field.onChange(event);
                    if (onChange) {
                        onChange(event);
                    }
                }}
                onBlur={(event: React.FocusEvent<any>) => {
                    field.onBlur(event);
                    if (onBlur) {
                        onBlur(event);
                    }
                }}
                onClick={(event: React.MouseEvent<any>) => {
                    if (onClick) {
                        onClick(event);
                    }
                }}
                InputLabelProps={InputLabelProps}
                inputProps={inputProps}
                InputProps={{
                    disableUnderline: true,
                    endAdornment: optional && !field.value && (
                        <div className="caption" style={{ color: THEME.customColors.body2Dark }}>
                            {t("screen.dataUpload.optional")}
                        </div>
                    ),
                    style: multiline ? { alignItems: "flex-end" } : {}
                }}
                fullWidth
                rows={multiline ? rows : undefined}
                select={select}
                type={type}
                disabled={disabled}
                error={showError}
                color="secondary"
                aria-label={props["aria-label"]}
                variant="filled"
                SelectProps={SelectProps}
            >
                {children}
            </TextField>
        </div>
    );
};
